// extracted by mini-css-extract-plugin
module.exports = {"view":"FullScreenView_view_TZnnO","iframe":"FullScreenView_iframe_2KXNf","close":"FullScreenView_close_2s8BB"};